import { PayloadLexicalReactRenderer, type PayloadLexicalReactRendererContent } from '@atelier-disko/payload-lexical-react-renderer';

type RichTextPayloadRendererProps = {
  children: PayloadLexicalReactRendererContent;
}

export const RichTextPayloadRenderer = ( { children }: RichTextPayloadRendererProps ) => {
  if ( !children ) {
    return null;
  }

  return (
    <PayloadLexicalReactRenderer
      content={ children }
    />
  );
};
RichTextPayloadRenderer.displayName = 'RichTextPayloadRenderer';
